var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"2.16125","y1":"1.93946","x2":"21.9602","y2":"21.7385","stroke":"white","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"2.03993","y1":"21.7383","x2":"21.8389","y2":"1.9393","stroke":"white","strokeWidth":"3","key":1})]);
}

Close.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = Close;

Close.default = Close;
